// extracted by mini-css-extract-plugin
export var root = "pagination-bar-module--root--ECj6-";
export var wrapper = "pagination-bar-module--wrapper--r3mNJ";